import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { LoudarLogo } from "./LoudarLogo";
import { Menu, X } from "lucide-react";

const links = [
  { label: "Features", href: "/features" },
  { label: "Mission", href: "/#mission" },
  { label: "Industry", href: "/#industry" },
];

export const Nav = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-nav"
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-loudar-ink/75 backdrop-blur-xl border-b border-white/[0.06]"
          : "bg-transparent"
      }`}
    >
      <div className="container-loudar flex h-16 items-center justify-between md:h-20">
        <a href="/" className="flex items-center" data-testid="nav-logo-link">
          <LoudarLogo className="h-10 md:h-12 text-white" />
          <sup
            className="ml-1 text-white/70 text-[10px] md:text-[11px] font-semibold tracking-normal select-none"
            aria-label="registered trademark"
          >
            ®
          </sup>
        </a>

        <nav className="hidden items-center gap-9 md:flex">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className="text-[12px] uppercase tracking-[0.22em] text-white/65 transition-colors hover:text-white"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <Link
            to="/pilot"
            data-testid="nav-cta-apply"
            className="hidden md:inline-flex items-center gap-2 rounded-sm border border-loudar-orange bg-loudar-orange/0 px-4 py-2 text-[11px] font-semibold uppercase tracking-[0.22em] text-loudar-orange transition-all hover:bg-loudar-orange hover:text-loudar-ink"
          >
            Join Waiting List
          </Link>
          <button
            type="button"
            className="md:hidden rounded-sm border border-white/15 p-2 text-white"
            onClick={() => setOpen((v) => !v)}
            data-testid="nav-mobile-toggle"
            aria-label="Toggle menu"
          >
            {open ? <X size={18} /> : <Menu size={18} />}
          </button>
        </div>
      </div>

      {open && (
        <div
          className="md:hidden border-t border-white/[0.06] bg-loudar-ink/95 backdrop-blur-xl"
          data-testid="nav-mobile-menu"
        >
          <div className="container-loudar flex flex-col gap-5 py-6">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="text-sm uppercase tracking-[0.22em] text-white/75"
                data-testid={`nav-mobile-link-${l.label.toLowerCase()}`}
              >
                {l.label}
              </a>
            ))}
            <Link
              to="/pilot"
              onClick={() => setOpen(false)}
              className="btn-primary mt-2"
              data-testid="nav-mobile-cta"
            >
              Join Waiting List
            </Link>
          </div>
        </div>
      )}
    </header>
  );
};

export default Nav;
